import React, { useState } from 'react';

/**
 * Cenzura imena: "HORVAT" → "H****T", "Ivan Horvat" → "I**n H****t".
 * Zrcali app/Support/NameMask.php. VAŽNO: maskira se samo PRIKAZ — pretraga/filter
 * ostaje na IZVORNOM imenu (komponenta prima puni name; filtriraj nad punim name-om).
 */
/** Jasni pravni sufiksi → tvrtka, NE maskiraj (zrcali NameMask.php). */
const COMPANY_SUFFIXES = ['d.o.o', 'd. o. o', 'd.d.', 'd. d.', 'j.d.o.o', 'jdoo', ' doo ', 'obrt', 'gmbh', ' ltd', ' inc', ' llc', 'a.d.', 's.p.', ' kg', ' ag', ' kft', ' sa ', ' bv '];

export function maskName(name?: string | null): string {
    const n = (name ?? '').trim();
    if (!n) return '—';
    const low = ` ${n.toLowerCase()} `;
    if (COMPANY_SUFFIXES.some((s) => low.includes(s))) return n; // tvrtka — čitljiva
    return n.split(/\s+/).map((w) => {
        const ch = Array.from(w);
        if (ch.length <= 1) return w;
        if (ch.length === 2) return ch[0] + '*';
        return ch[0] + '*'.repeat(ch.length - 2) + ch[ch.length - 1];
    }).join(' ');
}

/**
 * Prikaz cenzuriranog imena s klik-za-otkrivanje (po retku). Default = maskirano.
 * Klik na ime otkrije/sakrije puno ime (stopPropagation da ne otvori redak/drawer).
 */
export function MaskedName({ name, className, style, revealable = true }: {
    name?: string | null;
    className?: string;
    style?: React.CSSProperties;
    revealable?: boolean;
}) {
    const [reveal, setReveal] = useState(false);
    const full = (name ?? '').trim();
    if (!full) return <span className={className} style={style}>—</span>;
    if (!revealable) return <span className={className} style={style}>{maskName(full)}</span>;
    return (
        <span
            className={className}
            style={{ cursor: 'pointer', ...style }}
            title={reveal ? 'Klik za sakriti ime' : 'Klik za prikaz punog imena'}
            onClick={(e) => { e.stopPropagation(); setReveal((r) => !r); }}
        >
            {reveal ? full : maskName(full)}
        </span>
    );
}
